import { isMobileDevice } from '@/utils/deviceDetection';

/** The editor page's code, the route's lazy import; the module system loads it once however often it is called. */
export const loadEditorPage = () => import('./EditorPage');

let scheduled = false;

/** Fetches the editor's code while the browser is idle, so opening a story doesn't wait for it. Desktop only, as the editor is. */
export function prefetchEditorPage() {
  if (scheduled || isMobileDevice()) return;
  scheduled = true;
  const load = () => void loadEditorPage().catch(() => { scheduled = false; });
  if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 4000 });
  else setTimeout(load, 1500);
}
